export function TrustedBy() {
  return (
    <section className="py-24 bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-base font-semibold text-gray-500 dark:text-gray-400 tracking-wide uppercase">
            Trusted by {'>'} 1000 engineers from
          </h2>
          <div className="mt-12 grid grid-cols-2 gap-8 md:grid-cols-4 items-center justify-items-center">
            <div className="col-span-1 flex justify-center">
              <img
                className="h-12 w-auto grayscale hover:grayscale-0 transition-all duration-300 dark:brightness-150 dark:contrast-150"
                src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg"
                alt="Google"
              />
            </div>
            <div className="col-span-1 flex justify-center">
              <img
                className="h-12 w-auto grayscale hover:grayscale-0 transition-all duration-300 dark:brightness-150 dark:contrast-150"
                src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg"
                alt="Amazon"
              />
            </div>
            <div className="col-span-1 flex justify-center">
              <img
                className="h-12 max-h-12 object-contain grayscale hover:grayscale-0 transition-all duration-300 dark:brightness-150 dark:contrast-150"
                src="https://upload.wikimedia.org/wikipedia/commons/7/7b/Meta_Platforms_Inc._logo.svg"
                alt="Meta"
              />
            </div>
            <div className="col-span-1 flex justify-center">
              <img
                className="h-12 w-auto grayscale hover:grayscale-0 transition-all duration-300 dark:invert dark:brightness-90"
                src="https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg"
                alt="GitHub"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 